import * as React from 'react';

function SvgApplePayColourSquare(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="ApplePayColourSquare_svg__a"
        maskUnits="userSpaceOnUse"
        x={2}
        y={7}
        width={26}
        height={12}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 7h26v11.952H2V7z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#ApplePayColourSquare_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.295 10.152l1.599 3.922c.089.222.172.446.25.673.078.23.148.442.209.635h.026c.061-.185.131-.392.21-.623.078-.23.166-.467.262-.71l1.494-3.898H28l-1.821 4.426c-.167.428-.34.853-.518 1.276-.147.351-.311.695-.492 1.03-.15.282-.319.553-.505.812a3.433 3.433 0 01-.57.616c-.244.209-.47.362-.675.459a5.927 5.927 0 01-.412.182l-.21-.49c.18-.079.354-.167.524-.264.205-.12.395-.263.563-.428.158-.15.33-.35.518-.597a4.15 4.15 0 00.505-.899.98.98 0 00.079-.264.733.733 0 00-.079-.264l-2.268-5.595h.656zm-1.821 2.804a8.823 8.823 0 00-1.043.037 3.917 3.917 0 00-1.002.22c-.306.113-.56.279-.76.497-.2.217-.302.507-.302.867 0 .427.127.742.38.943.254.2.538.302.852.302.254 0 .481-.034.682-.101a1.745 1.745 0 001.128-1.094c.043-.168.065-.289.065-.365v-1.306zm.616 1.797c0 .243.005.487.013.73.009.242.035.477.079.703h-.577l-.091-.855h-.027a2.14 2.14 0 01-.301.352 2.301 2.301 0 01-.976.553c-.22.061-.448.09-.676.088-.305 0-.574-.048-.806-.144a1.535 1.535 0 01-.904-.911 1.732 1.732 0 01-.111-.604c0-.712.312-1.261.937-1.647.624-.385 1.566-.57 2.825-.553v-.163c0-.16-.016-.342-.046-.547a1.67 1.67 0 00-.204-.585 1.287 1.287 0 00-.471-.465c-.21-.126-.494-.189-.852-.189-.271 0-.54.04-.806.12-.267.08-.51.19-.728.333l-.196-.44c.279-.184.568-.316.864-.396.304-.08.617-.12.931-.12.437 0 .793.072 1.068.214.276.143.492.327.65.553.158.23.267.489.32.761.057.275.085.555.086.836v2.376zm-9.094-2.715c.149.041.314.07.498.087.184.017.38.025.59.025.786 0 1.396-.175 1.828-.527.432-.352.649-.868.649-1.547a2 2 0 00-.17-.855 1.541 1.541 0 00-.485-.597 2.249 2.249 0 00-.747-.352 3.598 3.598 0 00-.958-.12c-.28 0-.52.011-.72.032-.201.021-.363.044-.485.07v3.784zm-.617-4.224c.28-.046.559-.084.84-.114a9.289 9.289 0 011.009-.05c.524 0 .976.06 1.356.182.38.122.693.296.937.522.212.204.38.448.492.717.118.276.176.595.176.955 0 .436-.08.817-.242 1.144-.155.32-.381.6-.662.824-.28.221-.611.387-.996.496a4.614 4.614 0 01-1.258.163c-.41 0-.756-.029-1.035-.087v3.62h-.617V7.814zm-4.95.674c.342-.394.572-.942.51-1.488-.494.019-1.09.312-1.443.706-.318.349-.595.906-.52 1.441.55.04 1.111-.265 1.453-.66zM8.66 11.95c.014 1.41 1.3 1.88 1.315 1.885-.01.033-.205.669-.677 1.325-.409.568-.833 1.134-1.5 1.145-.656.012-.867-.37-1.617-.37s-.984.359-1.605.382c-.644.023-1.135-.614-1.546-1.18-.842-1.157-1.485-3.268-.621-4.694a2.417 2.417 0 012.027-1.167c.632-.012 1.23.404 1.616.404.387 0 1.113-.5 1.876-.427.32.013 1.216.123 1.791.924-.046.028-1.07.595-1.059 1.773z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default SvgApplePayColourSquare;
